let watermark = {}

let setWatermark = (str) => {
  let id = '1.23452384164.123412415'

  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
  }

  let can = document.createElement('canvas')
  can.width = 150
  can.height = 120

  let cans = can.getContext('2d')
  cans.rotate(-40 * Math.PI / 270)
  cans.font = '17px Microsoft YaHei'
  cans.fillStyle = 'rgba(0, 0, 0, 0.50)'
  cans.textAlign = 'left'
  cans.textBaseline = 'Middle'
  cans.fillText(str, can.width / 20, can.height )

  let div = document.createElement('div')
  div.id = id
  div.style.pointerEvents = 'none'
  div.style.top = '3px'
  div.style.left = '0px'
  div.style.position = 'fixed'
  div.style.opacity =  0.2;
  div.style.color = '#eee'
  div.style.zIndex = '1'
  div.style.width = document.documentElement.clientWidth  + 'px'
  div.style.height = document.documentElement.clientHeight  + 'px'
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
  document.body.appendChild(div)
  return id
}

// 该方法只允许调用一次
watermark.set = (str) => {
  let id = setWatermark(str);
  setInterval(() => {
    if (document.getElementById(id) === null) {
      id = setWatermark(str)
    }/* else{
      document.getElementById(id).style.height = getComputedStyle(document.getElementById('app')).height;
    } */
  }, 1000)
  window.onresize = () => {
    setWatermark(str)
  }
}

export default watermark



// WEBPACK FOOTER //
// ./src/assets/js/watermark.js